import moment from 'moment';

export default {
	setToken,
	getToken,
    getTokenRefreshTime,
	removeToken,
	setAppointment,
	getAppointment,
	removeAppointment
};

function setToken(token, bname) {
	localStorage.setItem('token', token);
	localStorage.setItem('bname', bname);
	localStorage.setItem('refreshTime', moment().unix())
}

function removeToken() {
	localStorage.removeItem('token');
	localStorage.removeItem('bname');
}

function getToken() {
	let token = localStorage.getItem('token');
	let bname = localStorage.getItem('bname');
	if (token && bname) {
		return { token, bname };
	} else {
		return null;
	}
}

function getTokenRefreshTime() {
    return localStorage.getItem('refreshTime');
}

function setAppointment(appointment) {
	localStorage.setItem('appointment', JSON.stringify(appointment));
}

function getAppointment() {
	let appointmentString = localStorage.getItem('appointment');
	if(appointmentString) {
		return JSON.parse(appointmentString);
	}
	return null;
}

function removeAppointment() {
	return localStorage.removeItem('appointment');
}
